import React from 'react';
import { FaInstagram } from 'react-icons/fa';

const ContactSocialIcons = () => {
  return (
    <div className="fixed bottom-8 right-8 z-50">
      <div className="flex flex-col items-center space-y-4">
        <a
          href="https://www.instagram.com/thezestytongue/"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-[#FF6838] text-white w-12 h-12 rounded-full flex items-center justify-center transition-transform duration-300 transform hover:scale-110 shadow-lg"
        >
          <FaInstagram className="text-2xl" />
        </a>
      </div>
    </div>
  );
};

export default ContactSocialIcons;